import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=2399eaf4"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"
import style0 from "./pie-chart.vue?vue&type=style&index=0&id=2399eaf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports